module.exports = __webpack_public_path__ + "img/login_bg.01b2cb0a.png";